export enum TrustedShopsIntegrationCustomType {
    CUSTOMERPORTAL = 'customerportal',
    CUSTOMERPORTAL_FAQ = 'customerportal_faq',
    CUSTOMERPORTAL_PROFILE = 'customerportal_profile',
    CUSTOMERPORTAL_REQUEST = 'customerportal_request',
    CUSTOMERPORTAL_FINANCING = 'customerportal_financing',
    CUSTOMERPORTAL_RENTING = 'customerportal_renting',
    CUSTOMERPORTAL_DOCUMENTS = 'customerportal_documents',
}
